import { render, staticRenderFns } from "./SaleLinkManagement.vue?vue&type=template&id=04155c45"
import script from "./SaleLinkManagement.vue?vue&type=script&lang=js"
export * from "./SaleLinkManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports